import type { ProgramEventInviteeRole } from 'models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type EventInviteesRoleOption = {
  label: string;
  value: 'all' | ProgramEventInviteeRole;
};

const eventInviteesRoleFilterOptions: EventInviteesRoleOption[] = [
  { label: 'All', value: 'all' },
  { label: 'Admin / Host', value: 'moderator' },
  { label: 'Presenter', value: 'presenter' },
  { label: 'Attendee', value: 'attendee' },
];

export const useEventInviteesRoleFilterOptions = () => {
  const { t } = useTranslation();

  return useMemo(() => eventInviteesRoleFilterOptions.map((option) => ({ ...option, label: t(option.label) })), [t]);
};
